module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.plan).length) ? _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 ls-display-flex flex-wrap-wrap"
  }, [_c('div', {
    staticClass: "col-md-8 col-xlg-7 col-lg-7 ls-display-flex align-itens-strech"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space ls-md-margin-bottom"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12 ls-float-left ls-no-padding"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-8 ls-no-padding"
  }, [_c('h4', {
    staticClass: "ls-title-3 ls-no-margin"
  }, [_vm._v(_vm._s(_vm.$t('plans.show.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-float-right"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "update_plan"
    }
  }, [_c('router-link', {
    staticClass: "ls-btn-primary ls-no-margin",
    attrs: {
      "to": {
        name: 'edit_plan',
        params: {
          id: _vm.plan.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('application.button.edit')))])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row ls-display-flex flex-wrap-wrap"
  }, [_c('label', {
    staticClass: "ls-label col-xs-6 col-lg-6 col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('plans.attributes.id')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md"
  }, [_vm._v(_vm._s(_vm.plan.id))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-6 col-lg-6 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('plans.attributes.code')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md"
  }, [_vm._v(_vm._s(_vm.plan.code))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-md-6 col-lg-6 col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('plans.show.plan_name')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md",
    attrs: {
      "data-test": "plan.name",
      "name": "plan.name"
    }
  }, [_vm._v(_vm._s(_vm.plan.name))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xlg-6 col-lg-6 col-xs-6"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('plans.show.since')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md"
  }, [_vm._v(_vm._s(_vm.date.parseDate(_vm.plan.created_at)))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-md-6 col-xlg-12 col-lg-12 col-xs-12"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('plans.edit.description')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md",
    attrs: {
      "data-test": "plan.description",
      "name": "plan.description"
    }
  }, [_vm._v(_vm._s(_vm.plan.description))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12 col-lg-12"
  }, [_c('h4', {
    staticClass: "ls-title-3"
  }, [_vm._v(_vm._s(_vm.$t('plans.edit.value_and_periodicity')))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-md-6 col-lg-6 col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('plans.show.charge')))]), _vm._v(" "), (_vm.periodCharge(_vm.plan.periodicity)) ? _c('p', {
    staticClass: "ls-text-md",
    attrs: {
      "data-test": "plan.periodicity"
    }
  }, [_vm._v(_vm._s(_vm.$t('plans.show.period_charge', {
    period: _vm.plan.periodicity
  })))]) : _c('p', {
    staticClass: "ls-text-md",
    attrs: {
      "data-test": "plan.periodicity"
    }
  }, [_vm._v(_vm._s(_vm.normalizePeriodicity(_vm.plan.periodicity)))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-md-6 col-lg-6 col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('plans.attributes.value')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md",
    attrs: {
      "data-test": "plan.price",
      "name": "plan.price"
    }
  }, [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(this.plan.price)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xlg-5 col-lg-5 ls-display-flex align-itens-strech"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space ls-md-margin-bottom"
  }, [_c('h4', {
    staticClass: "ls-title-3 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('plans.show.last_subscriptions')))]), _vm._v(" "), (_vm.contracts.length) ? _c('table', {
    staticClass: "ls-table ls-txt-center ls-sm-space fixed_header"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('plans.show.subscription')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('plans.attributes.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('plans.attributes.status')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contracts), function(contract) {
    return _c('tr', [_c('td', [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'contract_details',
          params: {
            id: contract.id
          }
        },
        "title": ""
      }
    }, [_vm._v(_vm._s(contract.id) + " "), _c('span', {
      staticClass: "ls-ico-shaft-right"
    })]), _c('div', [_vm._v(_vm._s(_vm.date.parseDate(contract.created_at)))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.customer.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('contracts.attributes.statuses.' + contract.status)))])])
  }))]) : _c('p', [_vm._v(_vm._s(_vm.$t('contracts.alerts.subscription_not_found')))]), _vm._v(" "), (_vm.contracts.length) ? _c('div', {
    staticClass: "ls-float-right"
  }, [_c('p', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "#",
      "title": _vm.$t('plans.show.view_all_subscriptions')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.redirectToContracts()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('plans.show.view_all_subscriptions'))), _c('span', {
    staticClass: "ls-ico-shaft-right ls-xs-margin-left"
  })])])]) : _vm._e()])])])]), _vm._v(" "), _c('modal-inactive', {
    model: {
      value: (_vm.inactiveObjects),
      callback: function($$v) {
        _vm.inactiveObjects = $$v
      },
      expression: "inactiveObjects"
    }
  }), _vm._v(" "), _c('modal-active', {
    model: {
      value: (_vm.activeObjects),
      callback: function($$v) {
        _vm.activeObjects = $$v
      },
      expression: "activeObjects"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e969774"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/plans/Show.vue
// module id = 774
// module chunks = 1